import { calculateVitalityStatus } from '../../compile/vitality-reader';
import type { PortEnv } from '../../port-contract';
import { catalogId, CATALOG_IDS } from './catalog';
/** PHP: VitalityStatus::calculateStatus (includes/additions.php:10718) */
export function vitalityStatusCalculateStatus(current: number, maximum: number, temp = 0, env: PortEnv<object>): string {
    const id = calculateVitalityStatus(current, maximum, temp);
    const variable = Object.keys(CATALOG_IDS).find(key => key.startsWith('VitalityStatus::') && CATALOG_IDS[key] === id)!.split('::')[1]!;
    return catalogId('VitalityStatus', variable, env);
}
